import { Component } from '@angular/core';
import {MonitoringService} from "./services/monitoring.service";
declare const $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'BackOffice';

  constructor(private monitoringService: MonitoringService) {
    console.log("Constructor: AppComponent")
  }

  onActivate(event: any) {
    let scrollToTop = window.setInterval(() => {
      let pos = window.scrollY;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  ngOnInit(): void {
    // $(document).ready(function() {
    //   $("body").tooltip({
    //     selector: '[data-toggle="tooltip"]',
    //     container: 'body'
    //   });

      /* $("body").popover({
        selector: '[data-toggle="popover"]',
        container: 'body'
      }) */
    // })

    /* $(function () {
      $('[data-toggle="popover"]').popover()
    }) */
  }
}
